import type { ValidatorType } from "shelving";
import { DataSchema, INTEGER, NON_NEGATIVE_INTEGER, getDaysAgo } from "shelving";

export const COUNTER_TYPES = {
	points: {
		title: "Points",
		icon: "star" as const,
		color: "yellow",
	},
	love: {
		title: "Big Love",
		icon: "heart" as const,
		color: "pink",
	},
};
export type CounterType = keyof typeof COUNTER_TYPES;

/** Counters are used to keep track of points and big love. */
export const COUNTER_SCHEMA = new DataSchema({
	props: {
		total: NON_NEGATIVE_INTEGER,
		streak: NON_NEGATIVE_INTEGER,
		updated: INTEGER,
	},
});
export type CounterData = ValidatorType<typeof COUNTER_SCHEMA>;

/** Empty counter */
export const EMPTY_COUNTER: CounterData = { total: 0, streak: 0, updated: 0 };

/** Get the current streak for a counter based on the current state of a counter. */
export function getCounterStreak({ streak, updated }: CounterData): number {
	return getDaysAgo(updated) > 1 ? 0 : streak;
}
